import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HardDrive } from 'lucide-react'
import { SourceDetailScreen } from '@/screens/connect/SCR-035-source-detail'

export const Route = createFileRoute('/_app/connect/sources_/$sourceId')({
  staticData: { screen: { id: 'SCR-035', title: 'Source detail', group: 'Connect', perm: 'connector.manage', hidden: true, description: 'One source: settings, health, certification, runs and what it produced.', icon: HardDrive } },
  validateSearch: z.object({ run: z.string().max(100).optional().catch(undefined) }),
  component: SourceDetailScreen,
})
